import request from '@/utils/http';

// 登陆后的首页
export const getRows = (params) => {
    return request({
        url: '/api-sn/home/identity/statistics',
        method: 'post',
        data: params
    }).then(res => res);
};

export const createTime = (time) => {
    const startTime = time + ' 00:00:00';
    const endTime = time + ' 23:59:59';
    return {
        startTime,
        endTime
    };
};

// 登录后首页（其他租户）- 条码采集量统计
export const getAcquisitionApi = (params) => {
    return request({
        url: `/api-sn/tenantIndex/getSwapStatistics`,
        method: 'post',
        data: params
    });
};
// 条码采集弹窗系统来源
export const getSourceSystem = (params) => {
    return request({
        url: '/api-sn/config/tenantSourcesysTable/downList',
        method: 'post',
        data: params
    }).then(res => res);
};

// 登陆后首页（其他租户）-页面操作延时TOP
export const getTimeDelayTopApi = (params) => {
    return request({
        url: '/api-sn/tenantIndex/selectTimeRequestReport',
        method: 'post',
        data: params
    }).then(res => res);
};

// 登陆后首页（其他租户）-页面操作延时TOP明细
export const getTimeDelayTopDetailApi = (params) => {
    return request({
        url: '/api-sn/tenantIndex/getApiCountPieChart',
        method: 'post',
        data: params
    }).then(res => res);
};
// 登陆后首页（其他租户）-页面操作频次TOP5
export const getTimeDelayApi = (params) => {
    return request({
        url: '/api-sn/tenantIndex/log/opRank',
        method: 'post',
        data: params
    }).then(res => res);
};

// 登陆后首页（其他租户）-中间表数据处理情况
export const getMiddleTableApi = (time) => {
    return request({
        url: `/api-sn/tenantIndex/getCollectBatchCollectStatistics/${time}`,
        method: 'get'
    });
};

// 登陆后首页（其他租户）-接口调用异常预警
export const getAbnormalWarnApi = (params) => {
    return request({
        url: `/api-sn/tenantIndex/getExceptionStatistics/${params.tenantCode}/${params.time}`,
        method: 'get'
    });
};

// 登陆后首页（其他租户）-接口调用异常预警-明细
export const getAbnormalDetailApi = (params) => {
    return request({
        url: '/api-sn/tenantIndex/getExceptionDetailStatistics',
        method: 'post',
        data: params
    }).then(res => res);
};

// 登陆后首页（其他租户-接口调用情况\接口调用统计
export const getCallSituationApi = (params, dataType) => {
    return request({
        url: `/api-sn/tenantIndex/bop/getTotalStatistics?dataType=${dataType || ''}`,
        method: 'post',
        data: params
    });
};

// 下拉
export const getProtName = (params) => {
    return request({
        url: `/api-sn/config/dataDictionaryDetails/downList`,
        method: 'post',
        data: params
    });
};
